"use client";

import { LanguageToggle } from "@/components/LanguageToggle";
import { useLanguage } from "@/lib/useLanguage";

type PublicFooterLanguageProps = {
  /** Dark marketing pages (slate) vs light static/legal pages */
  variant?: "dark" | "light";
};

export function PublicFooterLanguage({ variant = "dark" }: PublicFooterLanguageProps) {
  const { t } = useLanguage();
  const label = t.common?.language ?? "Language";

  const labelClass =
    variant === "dark"
      ? "text-slate-400"
      : "text-gray-500 dark:text-gray-400";

  return (
    <div className="flex flex-col items-center gap-2 sm:flex-row sm:justify-center sm:gap-3">
      <span className={`text-xs font-medium ${labelClass}`}>{label}</span>
      <LanguageToggle variant={variant === "dark" ? "footer-dark" : "footer-light"} />
    </div>
  );
}
